import type { ComponentProps } from "react";

type Props = {
  size?: number;
} & ComponentProps<"svg">;

export const OriginalIdIcon = ({ size = 16, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_419_28"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_419_28)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0667 12V5H1.93333V12H14.0667ZM15 5V12C15 12.2652 14.9017 12.5196 14.7266 12.7071C14.5516 12.8946 14.3142 13 14.0667 13H1.93333C1.6858 13 1.4484 12.8946 1.27337 12.7071C1.09833 12.5196 1 12.2652 1 12V5C1 4.73478 1.09833 4.48043 1.27337 4.29289C1.4484 4.10536 1.6858 4 1.93333 4H14.0667C14.3142 4 14.5516 4.10536 14.7266 4.29289C14.9017 4.48043 15 4.73478 15 5ZM2.86667 6.25C2.86667 6.1837 2.89125 6.12011 2.93501 6.07322C2.97877 6.02634 3.03812 6 3.1 6H5.36667C5.42855 6 5.4879 6.02634 5.53166 6.07322C5.57542 6.12011 5.6 6.1837 5.6 6.25V10.75C5.6 10.8163 5.57542 10.8799 5.53166 10.9268C5.4879 10.9737 5.42855 11 5.36667 11H3.1C3.03812 11 2.97877 10.9737 2.93501 10.9268C2.89125 10.8799 2.86667 10.8163 2.86667 10.75V6.25ZM7 8C6.87623 8 6.75753 8.05268 6.67002 8.14645C6.5825 8.24021 6.53333 8.36739 6.53333 8.5C6.53333 8.63261 6.5825 8.75979 6.67002 8.85355C6.75753 8.94732 6.87623 9 7 9H10.8C10.9238 9 11.0425 8.94732 11.13 8.85355C11.2175 8.75979 11.2667 8.63261 11.2667 8.5C11.2667 8.36739 11.2175 8.24021 11.13 8.14645C11.0425 8.05268 10.9238 8 10.8 8H7ZM6.53333 10.5C6.53333 10.3674 6.5825 10.2402 6.67002 10.1464C6.75753 10.0527 6.87623 10 7 10H12.6667C12.7904 10 12.9091 10.0527 12.9967 10.1464C13.0842 10.2402 13.1333 10.3674 13.1333 10.5C13.1333 10.6326 13.0842 10.7598 12.9967 10.8536C12.9091 10.9473 12.7904 11 12.6667 11H7C6.87623 11 6.75753 10.9473 6.67002 10.8536C6.5825 10.7598 6.53333 10.6326 6.53333 10.5ZM7 6C6.87623 6 6.75753 6.05268 6.67002 6.14645C6.5825 6.24021 6.53333 6.36739 6.53333 6.5C6.53333 6.63261 6.5825 6.75979 6.67002 6.85355C6.75753 6.94732 6.87623 7 7 7H11.7333C11.8571 7 11.9758 6.94732 12.0633 6.85355C12.1508 6.75979 12.2 6.63261 12.2 6.5C12.2 6.36739 12.1508 6.24021 12.0633 6.14645C11.9758 6.05268 11.8571 6 11.7333 6H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
